import {computed} from 'vue';

import {generatePageList} from './generatePageList';

import type {
    UsePaginationOptions,
    UsePaginationReturn,
    PageList,
} from './types';

export function usePagination({
    total,
    currentPage,
}: UsePaginationOptions): UsePaginationReturn {
    const totalValue = computed(() =>
        typeof total === 'number' ? total : total.value,
    );
    const currentPageValue = computed(() =>
        typeof currentPage === 'number' ? currentPage : currentPage.value,
    );

    const pageList = computed<PageList>(() =>
        generatePageList({
            total: totalValue.value,
            currentPage: currentPageValue.value,
        }),
    );

    const prevDisabled = computed(() => currentPageValue.value === 1);
    const nextDisabled = computed(
        () => totalValue.value <= currentPageValue.value,
    );

    return {
        pageList,
        prevDisabled,
        nextDisabled,
    };
}
